import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { DetailValue } from 'pages/track/Customers/CustomerDetail/StyledComponents';
import groupTicketsByTypeId from './groupTicketsByTypeId';

const TicketsList = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 8px 0 0 0;
  padding: 0;
`;

const TicketItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? 'rgba(255, 255, 255, 0.03)'
      : 'rgba(0, 0, 0, 0.03)'};
  border-radius: 6px;
  font-size: 14px;
`;

const TicketQuantity = styled.span`
  color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  font-weight: 600;
  margin-right: 8px;
`;

const TicketType = styled.span`
  color: ${(props) => (props.theme.name === 'dark' ? '#e2e8f0' : '#334155')};
`;

const TicketPrice = styled.span`
  color: ${(props) => props.theme?.colors?.success || '#22c55e'};
  font-weight: 500;
  white-space: nowrap;
`;

/**
 * Renders a transaction's purchased tickets as "Nx Name — price" rows,
 * grouped by ticket type id (see groupTicketsByTypeId).
 */
const TicketBreakdown = ({ tickets, emptyText }) => {
  if (!tickets || tickets.length === 0) {
    return <DetailValue>{emptyText}</DetailValue>;
  }

  return (
    <TicketsList>
      {groupTicketsByTypeId(tickets).map(
        ({ key, count, name, priceDisplay }) => (
          <TicketItem key={key}>
            <div>
              <TicketQuantity>{count}x</TicketQuantity>
              <TicketType>{name}</TicketType>
            </div>
            <TicketPrice>{priceDisplay}</TicketPrice>
          </TicketItem>
        )
      )}
    </TicketsList>
  );
};

TicketBreakdown.propTypes = {
  tickets: PropTypes.array,
  emptyText: PropTypes.string,
};

TicketBreakdown.defaultProps = {
  tickets: [],
  emptyText: 'No ticket details',
};

export default TicketBreakdown;
